export const scholarships = [
    {
        id: 1,
        name: "National Merit Scholarship",
        provider: "Govt. of India",
        amount: "₹50,000 / year",
        deadline: "31st Oct 2026",
        eligibility: ["Class 12 > 80%", "Family Income < 6LPA"],
        type: "Merit-based",
        category: "All Streams",
        tags: ["Government", "High Value"]
    },
    {
        id: 2,
        name: "Reliance Foundation Undergraduate Scholarship",
        provider: "Reliance Foundation",
        amount: "Up to ₹2,00,000",
        deadline: "15th Oct 2026",
        eligibility: ["First year UG", "Merit + Means"],
        type: "Private",
        category: "Engineering, Science",
        tags: ["Private", "Prestigious"]
    },
    {
        id: 3,
        name: "HDFC Badhte Kadam",
        provider: "HDFC Bank",
        amount: "₹1,00,000",
        deadline: "Starts August 2026",
        eligibility: ["Class 12 passed", "Family Income < 6LPA"],
        type: "Means-based",
        category: "General",
        tags: ["Banking", "Support"]
    },
    {
        id: 4,
        name: "AICTE Pragati Scholarship for Girls",
        provider: "AICTE",
        amount: "₹50,000 / year",
        deadline: "30th Nov 2026",
        eligibility: ["Girl Student", "Admitted to Diploma/Degree"],
        type: "Gender-based",
        category: "Engineering",
        tags: ["Women", "Govt"]
    },
    {
        id: 5,
        name: "Tata Trusts Medical and Healthcare",
        provider: "Tata Trusts",
        amount: "Varies (30-80%)",
        deadline: "31st Jan 2026",
        eligibility: ["Medical/Healthcare students", "Merit based"],
        type: "Merit-based",
        category: "Medical",
        tags: ["Medical", "Trust"]
    },
    {
        id: 6,
        name: "ONGC Scholarship for SC/ST",
        provider: "ONGC",
        amount: "₹48,000 / year",
        deadline: "Sept 2026",
        eligibility: ["SC/ST Category", "Engineering/Geology"],
        type: "Category-based",
        category: "Engineering",
        tags: ["PSU", "Reserved"]
    },
    {
        id: 7,
        name: "FTII Student Grant",
        provider: "Film & Television Institute of India",
        amount: "Up to ₹1,50,000",
        deadline: "Oct 2026",
        eligibility: ["Current Film students", "Merit-based"],
        type: "Institutional",
        category: "Design, Media",
        tags: ["Creative", "Media"]
    }
];
